/**
 * CL-DRAWINGS-007B-R4 — Shared client/trade individual drawing presentation eligibility.
 * Authorization is applied by callers; this layer only gates portal presentation.
 */

import { normalizePmFileReviewStatus } from "./clientDrawingReviewGroups";
import { isAdminManageableDrawingInventoryFile } from "./drawingInventoryModel";
import { isOverallDrawingPackage } from "./drawingDocumentRoleModel";
import { isStorageReadyForPortal } from "./projectFileStoragePublicationModel";

function lower(value) {
  return String(value ?? "").trim().toLowerCase();
}

function isCurrentDrawingLibraryRecord(file = {}) {
  if (!file || file.deleted === true) return false;
  if (lower(file?.status) === "deleted") return false;
  if (lower(file?.status) === "archived" || lower(file?.documentStatus) === "archived") return false;
  if (normalizePmFileReviewStatus(file?.reviewStatus) === "superseded") return false;
  return true;
}

/**
 * Individual drawing file eligible for client portal library presentation (not authorization).
 */
export function isClientPortalIndividualDrawing(file = {}) {
  if (!file || !isAdminManageableDrawingInventoryFile(file)) return false;
  if (!isCurrentDrawingLibraryRecord(file)) return false;
  if (isOverallDrawingPackage(file)) return false;
  if (!isStorageReadyForPortal(file)) return false;
  if (lower(file?.visibility) === "admin" || lower(file?.visibility) === "internal") return false;
  return true;
}
